<div
  class="social-share-card mt-4 highlighted"
  (click)="shareOnInvite()"
  *ngIf="checkInvitations"
>
  <div class="flex align-items-center gap-2 share-card-content">
    <img src="/assets/media/icons/invite.png" />
    <h4 class="m-0">Invita i tuoi contatti</h4>
  </div>
</div>
<div class="social-share-card mt-2" (click)="shareOn('facebook')">
  <div class="flex align-items-center gap-2 share-card-content">
    <img src="/assets/media/icons/facebook-share.png" />
    <h4 class="m-0">Condividi su Facebook</h4>
  </div>
</div>
<!-- <div class="social-share-card mt-4">
    <div class="flex align-items-center gap-2 share-card-content">
        <img src="/assets/media/icons/instagram-share.png">
        <h4 class="m-0">Condividi su Instagram</h4>
    </div>
</div> -->
<div class="social-share-card mt-4" (click)="shareOn('twitter')">
  <div class="flex align-items-center gap-2 share-card-content">
    <img src="/assets/media/icons/twitter-share.png" />
    <h4 class="m-0">Condividi su X</h4>
  </div>
</div>
<div class="social-share-card mt-4" (click)="shareOn('whatsapp')">
  <div class="flex align-items-center gap-2 share-card-content">
    <img src="/assets/media/icons/whatsapp.png" />
    <h4 class="m-0">Condividi su Whatsapp</h4>
  </div>
</div>
<div class="social-share-card mt-4" (click)="copyLink()">
  <div class="flex align-items-center gap-2 share-card-content">
    <img src="/assets/media/icons/link.png" />
    <h4 class="m-0">Copia link</h4>
  </div>
</div>
<div class="social-share-card mt-4" (click)="shareViaEmail()">
  <div class="flex align-items-center gap-2 share-card-content">
    <img src="/assets/media/icons/email.png" />
    <h4 class="m-0">Condividi tramite email</h4>
  </div>
</div>
<!-- <div class="social-share-card mt-4" (click)="printPage()">
    <div class="flex align-items-center gap-2 share-card-content">
        <img src="/assets/media/icons/printing.png">
        <h4 class="m-0">Stampa</h4>
    </div>
</div> -->
